import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

export const gerarChaveCandidato = (item) => {
  return item?.idInterno || "";
};

const extrairTitulosComPosicao = (docSnap) => {
  if (!docSnap || !docSnap.exists()) return [];

  const data = docSnap.data();
  const apostas = [];

  Object.entries(data).forEach(([key, value]) => {
    const temTituloValido =
      typeof value === "object" &&
      typeof value.titulo === "string" &&
      value.titulo.trim() !== "";

    if (!isNaN(key) && temTituloValido) {
      apostas.push({
        titulo: value.titulo,
        imagem: value.imagem || "",
        filme: value.filme || "",
        pais: value.pais || "",
        idInterno: value.idInterno || "",
        ordem: parseInt(key)
      });
    }
  });

  return apostas;
};

const atualizarPopularidade = async (uid, modo, categoria, novaAposta, apostaAntigaSnap) => {
  const apostasAntigas = extrairTitulosComPosicao(apostaAntigaSnap);
  const apostasNovas = novaAposta.map((a, i) => ({
    titulo: a.titulo,
    imagem: a.imagem || "",
    filme: a.filme || "",
    pais: a.pais || "",
    idInterno: a.idInterno || "",
    ordem: i + 1
  }));

  const chavesAntigas = apostasAntigas.map(item => gerarChaveCandidato(item));
  const chavesNovas = apostasNovas.map(item => gerarChaveCandidato(item));

  if (chavesNovas.length === 0) {
    console.warn("⛔ Nenhuma chave válida na nova aposta. Popularidade não será atualizada.");
    return;
  }

  // 🔍 Verifica se o usuário é especialista
  let caminhoBase = `popularidade/${modo}/categorias/${categoria}`;
  try {
    const snapUsuario = await getDoc(doc(db, "usuarios", uid));
    const dadosUsuario = snapUsuario.exists() ? snapUsuario.data() : {};

    if (dadosUsuario.especialista === true) {
      caminhoBase = `popularidadeespecialistas/${modo}/categorias/${categoria}`;
    }
  } catch (erro) {
    console.warn("⚠️ Erro ao verificar se é especialista:", erro);
  }

  // 🔄 Buscar dados existentes da popularidade
  const refPop = doc(db, caminhoBase);
  const snapPop = await getDoc(refPop);

  const dadosPop = snapPop.exists()
    ? structuredClone(snapPop.data())
    : {
        totalUsuarios: 0,
        candidatos: {},
        usuarios: {}
      };

  // ➖ Subtrair votos antigos
  chavesAntigas.forEach((chave, index) => {
    const pos = (apostasAntigas[index]?.ordem || 0).toString();
    if (!dadosPop.candidatos[chave]) return;

    dadosPop.candidatos[chave].vezesEscolhido = Math.max(
      0,
      (dadosPop.candidatos[chave].vezesEscolhido || 0) - 1
    );

    if (pos && dadosPop.candidatos[chave].posicoes?.[pos]) {
      dadosPop.candidatos[chave].posicoes[pos] = Math.max(
        0,
        dadosPop.candidatos[chave].posicoes[pos] - 1
      );
    }
  });

  // ➕ Adicionar votos novos
chavesNovas.forEach((chave, index) => {
  const pos = (apostasNovas[index]?.ordem || 0).toString();
  const dados = apostasNovas[index];

  if (!dadosPop.candidatos[chave]) {
    dadosPop.candidatos[chave] = {
      titulo: (dados.titulo || "").trim(),
      imagem: dados.imagem || "",
      filme:  dados.filme  || "",
      pais:   dados.pais   || "",
      idInterno: dados.idInterno || "",
      vezesEscolhido: 0,
      posicoes: {}
    };
  } else {
    const c = dadosPop.candidatos[chave];
    if (typeof dados.titulo === "string" && dados.titulo.trim()) c.titulo = dados.titulo.trim();
    if (typeof dados.filme  === "string" && dados.filme.trim())  c.filme  = dados.filme.trim();
    if (typeof dados.pais   === "string" && dados.pais.trim())   c.pais   = dados.pais.trim();
    if (typeof dados.imagem === "string" && dados.imagem)         c.imagem = dados.imagem;
    if (dados.idInterno) c.idInterno = dados.idInterno;
  }

  dadosPop.candidatos[chave].vezesEscolhido += 1;
  dadosPop.candidatos[chave].posicoes[pos] =
    (dadosPop.candidatos[chave].posicoes[pos] || 0) + 1;
});

  // ✅ Contagem de usuários
  const idUsuarioPop = `uid_${uid}`;
  if (!dadosPop.usuarios) dadosPop.usuarios = {};
  const jaContribuiuAntes = dadosPop.usuarios[idUsuarioPop] === true;

  if (chavesNovas.length > 0 && !jaContribuiuAntes) {
    dadosPop.totalUsuarios += 1;
    dadosPop.usuarios[idUsuarioPop] = true;
  } else if (chavesNovas.length === 0 && jaContribuiuAntes) {
    dadosPop.totalUsuarios = Math.max(0, dadosPop.totalUsuarios - 1);
    delete dadosPop.usuarios[idUsuarioPop];
  }

  if (Object.keys(dadosPop.candidatos).length === 0) {
    console.warn("⛔ Nenhum dado de candidatos após atualização. Documento não será salvo.");
    return;
  }

  await setDoc(refPop, {
    ...dadosPop,
    ultimaAtualizacao: new Date().toISOString()
  });

  console.log(`✅ Popularidade (${caminhoBase}) atualizada com sucesso`);
};

export default atualizarPopularidade;